
export default {

    device_data:
    {
        time: ["2018-06-01 10:00", "2018-06-01 10:10", "2018-06-01 10:20", "2018-06-01 10:30", "2018-06-01 10:40", "2018-06-01 10:50", "2018-06-01 11:00", "2018-06-01 11:10", "2018-06-01 11:20", "2018-06-01 11:30", "2018-06-01 11:40", "2018-06-01 11:50", "2018-06-01 12:00", "2018-06-01 12:10", "2018-06-01 12:20", "2018-06-01 12:30", "2018-06-01 12:40", "2018-06-01 12:50", "2018-06-01 13:00", "2018-06-01 13:10", "2018-06-01 13:20", "2018-06-01 13:30", "2018-06-01 13:40", "2018-06-01 13:50", "2018-06-01 14:00", "2018-06-01 14:10", "2018-06-01 14:20", "2018-06-01 14:30", "2018-06-01 14:40", "2018-06-01 14:50"],
        air_temperature: [28.25, 27.99, 28.92, 28.3, 29.35, 28.31, 28.49, 29.08, 29.71, 29.61, 27.24, 28.24, 28.11, 26.1, 25.64, 26.54, 25.15, 25.56, 24.59, 24.37, 25.5, 26.36, 27.32, 27.79, 28.72, 27.84, 26.82, 27.91, 28.06, 27.29],
        air_humidity: [28.25, 27.99, 28.92, 28.3, 29.35, 28.31, 28.49, 29.08, 29.71, 29.61, 27.24, 28.24, 28.11, 26.1, 25.64, 26.54, 25.15, 25.56, 24.59, 24.37, 25.5, 26.36, 27.32, 27.79, 28.72, 27.84, 26.82, 27.91, 28.06, 27.29],
        air_pressure: [28.25, 27.99, 28.92, 28.3, 29.35, 28.31, 28.49, 29.08, 29.71, 29.61, 27.24, 28.24, 28.11, 26.1, 25.64, 26.54, 25.15, 25.56, 24.59, 24.37, 25.5, 26.36, 27.32, 27.79, 28.72, 27.84, 26.82, 27.91, 28.06, 27.29],
        rain_rate: [28.25, 27.99, 28.92, 28.3, 29.35, 28.31, 28.49, 29.08, 29.71, 29.61, 27.24, 28.24, 28.11, 26.1, 25.64, 26.54, 25.15, 25.56, 24.59, 24.37, 25.5, 26.36, 27.32, 27.79, 28.72, 27.84, 26.82, 27.91, 28.06, 27.29],
        solar_radiation: [28.25, 27.99, 28.92, 28.3, 29.35, 28.31, 28.49, 29.08, 29.71, 29.61, 27.24, 28.24, 28.11, 26.1, 25.64, 26.54, 25.15, 25.56, 24.59, 24.37, 25.5, 26.36, 27.32, 27.79, 28.72, 27.84, 26.82, 27.91, 28.06, 27.29],
        soil_temperature: [28.25, 27.99, 28.92, 28.3, 29.35, 28.31, 28.49, 29.08, 29.71, 29.61, 27.24, 28.24, 28.11, 26.1, 25.64, 26.54, 25.15, 25.56, 24.59, 24.37, 25.5, 26.36, 27.32, 27.79, 28.72, 27.84, 26.82, 27.91, 28.06, 27.29],
        soil_moisture: [28.25, 27.99, 28.92, 28.3, 29.35, 28.31, 28.49, 29.08, 29.71, 29.61, 27.24, 28.24, 28.11, 26.1, 25.64, 26.54, 25.15, 25.56, 24.59, 24.37, 25.5, 26.36, 27.32, 27.79, 28.72, 27.84, 26.82, 27.91, 28.06, 27.29],
        soil_conductivity: [28.25, 27.99, 28.92, 28.3, 29.35, 28.31, 28.49, 29.08, 29.71, 29.61, 27.24, 28.24, 28.11, 26.1, 25.64, 26.54, 25.15, 25.56, 24.59, 24.37, 25.5, 26.36, 27.32, 27.79, 28.72, 27.84, 26.82, 27.91, 28.06, 27.29],
        voltage: [8, 7, 6, 5, 4.2, 4.2, 4.2, 4.0, 4.1, 4.0, 4.0, 4.0, 3.9, 3.9, 3.8, 3.8, 3.8, 3.7, 3.7, 3.7, 3.6, 3.6, 3.6, 3.5, 3.5, 3.5, 3.5, 3.4, 3.3, 3.2],
        voltage_to_battery_percentage: undefined,
    },

    cameraDevice: {
        "hashid": "CA4m89rg",
        "deviceid": 35,
        "gateway_hashid": "GWy02xko",
        "type": "camera",
        "nickname": "縮時攝影",
        "latitude": 22.7135,
        "longtitude": 120.4236,
        "description": "縮時攝影:CA4m89rg",
        "sensor_params": [],
        "visualization": [],
    },
    cameraPhoto: [
        {
            date: '2019-01-01 18:00',
            description: '12345678910. 25464. ljhkgf khjhfuiygfyu jhgkugghgkgukuul',
            url: 'https://storage.googleapis.com/turtwig-xlab-storage/cropperiods/pics/ffade996-88f1-4561-9680-07ca0ce11b12.jpg?0.17587249544588845',
        },
        {
            date: '2019-01-02 18:00',
            description: '12345678910.',
            url: 'https://storage.googleapis.com/turtwig-xlab-storage/cropperiods/pics/277857e2-8501-4800-8f57-e2bd18221995.jpg?0.8934180304697782',
        },
        {
            date: '2019-01-03 18:00',
            description: '12345678910. 25464. ljhu jhgkugghgkgukuul',
            url: 'https://storage.googleapis.com/turtwig-xlab-storage/cropperiods/pics/64ac203b-6ae8-4649-bc15-59bcb3a4f366.jpg?0.2548720084810887',
        },
        {
            date: '2019-01-04 18:00',
            description: '12345678910. 25464. ljhkgf khjhfuiygfyu jhgkugghgkgukuul ghgkgukuu ghgkgukuu',
            url: 'https://storage.googleapis.com/turtwig-xlab-storage/cropperiods/pics/f241bab9-8804-4804-9aac-174047ba38a6.jpg?0.4690745101718292',
        },
        {
            date: '2019-01-05 18:00',
            description: '12345678910. 25464. ljhkgf khjhfuiygfyu jhgkugghgkgukuul',
            url: '',
        },
        {
            date: '2019-01-06 18:00',
            description: '12345678910. 25464. ljhkgf khjhfuiygfyu jhgkugghgkgukuul',
            url: undefined,
        },
        {
            date: '2019-01-07 18:00',
            description: '12345678910. 25464. ljhkgf khjhfuiygfyu jhgkugghgkgukuul',
            url: 'https://storage.googleapis.com/turtwig-xlab-storage/projects/pics/4fd579e6-72b9-4f89-8a6f-f22f20163430.jpg?0.9593590696106192',
        },
        {
            date: '2019-01-08 18:00',
            description: '12345678910. 25464. ljhkgf khjhfuiygfyu jhgkugghgkgukuul',
            url: 'https://storage.googleapis.com/turtwig-xlab-storage/cropperiods/pics/ffade996-88f1-4561-9680-07ca0ce11b12.jpg?0.17587249544588845',
        },
        {
            date: '2019-01-09 18:00',
            description: '12345678910. 25464. ljhkgf khjhfuiygfyu jhgkugghgkgukuul',
            url: 'https://storage.googleapis.com/turtwig-xlab-storage/cropperiods/pics/ffade996-88f1-4561-9680-07ca0ce11b12.jpg?0.17587249544588845',
        },
    ],
}